export const isAudioSessionType = (sessionType?: string | null): boolean =>
  sessionType === 'upload' || sessionType === 'on_device';
